export default "<p>pippo works!</p>\n"